import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TagsInput from 'components/form/tagsinput'
import { cond, isEmpty, always, either, isNil, defaultTo, any } from 'ramda'
import withFieldError from 'components/form/with-error'

export const MatchKeyword = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <div
    className={error && touched && 'has-error'}
    style={{ borderRadius: '2px' }}
  >
    <TagsInput
      inputProps={{
        placeholder: 'Enter keyword e.g. keyword',
        className: 'react-tagsinput-input input-medium',
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      addOnBlur
      value={value}
      onChange={onChange}
    />
  </div>
)

MatchKeyword.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const MatchKeywordWithError = withFieldError(MatchKeyword)

export const validate = cond([
  [either(isEmpty, isNil), always('Please enter a keyword')],
  [
    any(window.twttr.txt.isInvalidTweet),
    always('Keyword too long, please enter a valid keyword')
  ]
])

const MatchKeywordField = ({ name }) => (
  <div>
    <Field
      name={`${name}.value`}
      component={MatchKeywordWithError}
      validate={validate}
      format={defaultTo([])}
    />
  </div>
)

MatchKeywordField.propTypes = {
  name: PropTypes.string
}

export default MatchKeywordField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/twitter/match-keyword/index.js